import React from "react";

/** CSS */
import "./PageLoader.scss";

const PageLoader = () => {
    return (
        <div className="loader-wrapper">
            <div className="loading-spinner">
                <div id="square1"></div>
                <div id="square2"></div>
                <div id="square3"></div>
                <div id="square4"></div>
                <div id="square5"></div>
            </div>
        </div>
    );
};

export default PageLoader;